import swal from 'sweetalert2';
import { Component, ElementRef, Input, OnDestroy, OnInit, SecurityContext } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { ChamadosService } from "src/app/services/chamados.service";
import { environment } from "src/environments/environment";
import { ModalListaContatosClienteComponent } from "../modal-lista-contatos-cliente/modal-lista-contatos-cliente.component";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from "@angular/forms";
import { ChatGPTService } from "src/app/services/chat-gpt.service";
import { ChatGPTSuggestionModel } from "src/app/models/chat-gpt/chat-gpt-suggestion.model";
import { ModalAdicionarTemplateComponent } from "../modal-adicionar-template/modal-adicionar-template.component";
import { DomSanitizer } from "@angular/platform-browser";
import Editor from 'src/assets/ckeditor5-41.3.0/build/ckeditor';
import { StripHtmlPipe } from 'src/app/shared/validators/pipes/stripHtml.pipe';
import { ModalOpenAITemplateComponent } from '../modal-openai-template/modal-openai-template.component';
import { ChatService } from 'src/app/services/chat.service';
import { TicketService } from 'src/app/services/ticket.service';
import { cloneDeep } from 'lodash';
import { IaConfiguracaoFeatureEnum } from 'src/app/enums/integration/iaConfiguracaoFeature.enum';

@Component({
  selector: "app-modal-enviar-email",
  templateUrl: "./modal-enviar-email.component.html",
  styleUrls: ["./modal-enviar-email.component.scss"],
})
export class ModalEnviarEmailComponent implements OnInit, OnDestroy {
  sendEmailFromTicketForm: UntypedFormGroup = new UntypedFormGroup({
    chatGPT: new UntypedFormControl("", Validators.required),
    subject: new UntypedFormControl("", Validators.required)
  });
  @Input() emailData;
  @Input() chatEmailData;
  @Input() chatContatosContext;
  envioEmail = {
    destinatarios: [],
    assunto: "",
    descricao_html: "",
    anexos: [],
  };
  cliente_id;
  anexos = [];
  limit_max = 5;
  template;
  emailContato;
  contato;
  templateButton;
  assuntoTemplate;
  selector: string;
  newSubs: Subscription;
  logFooter: string = "";
  descricao_aux = "";
  usarDelimitadorEmail: boolean = false;
  editor;
  uploadFileType = environment.getUploadConfig().docImg();
  uploadFileSize = 26214400;
  salvando: boolean = false;
  chatEmailProps: any;
  public Editor = Editor;
  public editorModel: { editorData: string | null } = {
    editorData: null,
  };

  constructor(
    public modal: NgbActiveModal,
    private toastr: ToastrService,
    public translate: TranslateService,
    private chamadosService: ChamadosService,
    private modalService: NgbModal,
    private elemRef: ElementRef,
    private chatGPTService: ChatGPTService,
    private _sanitizer: DomSanitizer,
    private stripHtmlPipe: StripHtmlPipe,
    private chatService: ChatService,
    private ticketService: TicketService
  ) {
    this.selector = this.elemRef.nativeElement.tagName.toLowerCase();
  }

  ngOnInit(): void {
    document.getElementsByTagName(this.selector)[0]["style"]["zoom"] = "0.85";
    if (this.chatEmailData) {
      if (this.chatEmailData.is_iniciar_conversa) {
        this.emailContato = [{ display: this.chatEmailData.destinatario, value: this.chatEmailData.destinatario }];
        this.envioEmail.destinatarios = [this.chatEmailData.destinatario];
        this.editorModel.editorData = '';
        this.newSubs = this.chatService.validarIntegracaoChamarEmailChat().subscribe({
          next: (cfg) => {
            if (cfg) {
              this.chatEmailProps = {
                ia_habilitada_email: cfg.ia_habilitada_email,
                integracao_email_chat_disponivel: cfg.integracao_email_chat_disponivel
              };
            }
          },
          error: (error) => console.error(error)
        });
      } else {
        const payload = this.chatEmailData.message_id
          ? { message_id_alvo: this.chatEmailData.message_id }
          : {};

        this.newSubs = this.chatService.preparaRespostaChatEmail(payload, this.chatEmailData.chat_id)
          .subscribe({
            next: (results) => {
              if (results) {
                this.chatEmailProps = results;
                this.emailContato = [];
                if (results.destinatarios.length) {
                  for (let dest of results.destinatarios) {
                    this.emailContato.push({
                      display: dest,
                      value: dest,
                    });
                  }
                } else if (results.participantes_abertura?.para.length) {
                  this.emailContato.push({
                    display: results.participantes_abertura?.para[0].address,
                    value: results.participantes_abertura?.para[0].address,
                  });
                }

                if (results.cc.length) {
                  for (let cc of results.cc) {
                    this.emailContato.push({
                      display: cc,
                      value: cc,
                    });
                  }
                }
                this.envioEmail.destinatarios = this.emailContato;
                this.envioEmail.assunto = results.assunto;
                const possuiMensagemAlvo = !!this.chatEmailData.message_id;
                const corpoCitacaoEditor = possuiMensagemAlvo ? (results.corpo_inicial_html || '').trim() : '';
                const htmlEditorRespostaChat = corpoCitacaoEditor
                  ? this.montarHtmlEditorRespostaChat(corpoCitacaoEditor, results.delimitador)
                  : '<p><br></p>';
                this.editorModel.editorData = htmlEditorRespostaChat;
                if (typeof this.editor?.setData === 'function') {
                  this.editor.setData(htmlEditorRespostaChat);
                }
              }
            }, error: (error) => console.error(error)
          });
      }
    } else {
      if (this.emailData.chamado) {
        this.envioEmail.assunto = this.emailData.chamado.assunto;
        this.cliente_id = this.emailData.chamado.cliente.id;
        this.checkEmailContatos();

        if (this.emailData.log) {
          this.logFooter = this.montarLogFooterPadrao(this.emailData.log);
          this.descricao_aux = this.envioEmail.descricao_html;
          this.editorModel.editorData = this.logFooter;
        }
      }

      if (this.emailData.suggestion && this.emailData.suggestion.sugestao_html) {
        this.editorModel.editorData = this.emailData.suggestion.sugestao_html;
      }

      if (this.emailData.pecas) {
        var _linhasPecas = "";
        this.emailData.pecas.produtos.forEach((produto) => {
          _linhasPecas +=
            "<tr><td>" +
            produto.nome +
            "</td><td>" +
            produto.qtd +
            "</td><td>" +
            produto.valor_unitario +
            "</td><td>" +
            produto.valor_total +
            "</td></tr>";
        });

        this.envioEmail.assunto =
          this.translate.instant("PECAS_NECESSARIAS_TICKET") +
          "#" +
          this.emailData.chamado.codigo;
        const data =
          "<table class='table table-hover table-responsive table-bordered'><thead><tr><th class='w-50'>" +
          this.translate.instant("PECAS_SELECIONADAS") +
          "</th><th>QTD</th><th>" +
          this.translate.instant("LBL_PRECO") +
          "</th><th>" +
          this.translate.instant("TOTAL") +
          "</th></tr></thead><tbody>" +
          _linhasPecas +
          "</tbody><tfoot style='border: none;'><tr style='border: none;'><td colspan='2' style='border: none;'></td><td style='border: none;'>" +
          this.translate.instant("TOTAL") +
          "</td><td colspan='2' style='border: none;'>" +
          this.emailData.pecas.valor_total +
          "</td></tr></tfoot></table>";
        this.editorModel.editorData = data;
        this.descricao_aux = this.envioEmail.descricao_html;
      }

      this.checkAssinaturaEmail();
      this.checkChatGPTSuggestion();
    }

    this.carregarConfigDelimitadorEAjustarCorpo();
  }

  private montarLogFooterPadrao(log: any): string {
    const date = new Date(log.data_criacao);
    const minutosFormatados = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    return (
      "<br><hr><br>" +
      this.translate.instant("DATA") +
      ": " +
      date.getDate() +
      "/" +
      (date.getMonth() + 1) +
      "/" +
      date.getFullYear() +
      " " +
      date.getHours() +
      ":" +
      minutosFormatados +
      "<br>" +
      this.montarCabecalhoEmailLog(log) +
      (log.observacao_html ? log.observacao_html.replaceAll("<td>", "<td style='border: none;'>") : "")
    );
  }

  private textoDelimitadorResposta(): string {
    const lang = (this.translate.currentLang || this.translate.defaultLang || 'pt').toLowerCase().slice(0, 2);
    if (lang === 'en') {
      return '##-Please type your reply above this line -##';
    }
    if (lang === 'es') {
      return '##-Por favor, escriba su respuesta encima de esta línea -##';
    }
    return '##-Por favor, digite sua resposta acima desta linha -##';
  }

  private obterTextoDelimitadorRespostaChat(textoDelimitadorApi?: string): string {
    return (textoDelimitadorApi || this.chatEmailProps?.delimitador || '').trim() || this.textoDelimitadorResposta();
  }

  private montarHtmlEditorRespostaChat(corpoCitacaoEditor: string, textoDelimitadorApi?: string): string {
    const textoDelimitador = this.obterTextoDelimitadorRespostaChat(textoDelimitadorApi);
    const corpoCitacaoHtml = (corpoCitacaoEditor || '').trim();

    if (!corpoCitacaoHtml) {
      return `<p><br></p><blockquote><p>${textoDelimitador}</p></blockquote>`;
    }

    return `<p><br></p><blockquote><p>${textoDelimitador}</p>${corpoCitacaoHtml}</blockquote>`;
  }

  private formatarDataHoraLog(dataCriacao: any): string {
    const date = new Date(dataCriacao);
    const dia = date.getDate().toString().padStart(2, '0');
    const mes = (date.getMonth() + 1).toString().padStart(2, '0');
    const ano = date.getFullYear();
    const hora = date.getHours().toString().padStart(2, '0');
    const minutos = date.getMinutes().toString().padStart(2, '0');
    return `${dia}/${mes}/${ano} ${hora}:${minutos}`;
  }

  private escapeHtml(value: any): string {
    return (value === null || value === undefined ? '' : value.toString())
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  private formatarLinhaRemetenteLog(log: any): string {
    const dataHora = this.formatarDataHoraLog(log.data_criacao);
    const nome = (log.contato || log.email_criador || '').toString().trim();
    const email = (log.email_criador || '').toString().trim();
    const remetente = nome && email && nome !== email ? `${nome} <${email}>` : (nome || email);
    return `${this.escapeHtml(dataHora)} - ${this.escapeHtml(remetente)} ${this.escapeHtml(this.translate.instant('ESCREVEU'))}: `;
  }

  // Cabecalho De/Para/Assunto/CC exibido na resposta (abaixo do delimitador, ou no rodape legado).
  private montarCabecalhoEmailLog(log: any): string {
    if (!log) {
      return '';
    }

    const linhas: string[] = [];

    if (log.is_email_enviado) {
      if (log.contato) {
        linhas.push(`${this.escapeHtml(this.translate.instant('PARA'))}: ${this.escapeHtml(log.contato)}`);
      }
      if (log.email_assunto) {
        linhas.push(`${this.escapeHtml(this.translate.instant('ASSUNTO'))}: ${this.escapeHtml(log.email_assunto)}`);
      }
    } else if (log.is_email_recebido) {
      if (log.email_criador) {
        linhas.push(`${this.escapeHtml(this.translate.instant('DE'))}: ${this.escapeHtml(log.email_criador)}`);
      }
      if (log.email_para) {
        const dataHora = this.formatarDataHoraLog(log.data_criacao);
        linhas.push(`${this.escapeHtml(this.translate.instant('PARA'))}: ${this.escapeHtml(log.email_para)} ${this.escapeHtml(this.translate.instant('EM'))} ${this.escapeHtml(dataHora)}`);
      }
      if (log.cc) {
        linhas.push(`CC: ${this.escapeHtml(log.cc)}`);
      }
    }

    if (!linhas.length) {
      return '';
    }

    return `<p><small>${linhas.join('<br>')}</small></p>`;
  }

  private montarBlocoDelimitador(): string {
    const delimitador = this.textoDelimitadorResposta();
    const assinaturaHtml = this.emailData?.emailSignature?.assinatura_html || '';
    const blocoAssinatura = assinaturaHtml ? `<br>${assinaturaHtml}` : '';
    const blocoDelimitador = `<p>${delimitador}</p>`;
    const linhaRemetente = this.formatarLinhaRemetenteLog(this.emailData.log);
    const observacaoHtml = this.emailData.log.observacao_html
      ? this.emailData.log.observacao_html.replaceAll("<td>", "<td style='border: none;'>")
      : '';
    const cabecalhoEmail = this.montarCabecalhoEmailLog(this.emailData.log);
    return (
      blocoAssinatura +
      `<p><small>${linhaRemetente}</small></p>` +
      blocoDelimitador +
      cabecalhoEmail +
      `<blockquote>${observacaoHtml}</blockquote>`
    );
  }

  private carregarConfigDelimitadorEAjustarCorpo(): void {
    if (this.chatEmailData || !this.emailData?.log) {
      return;
    }

    this.newSubs = this.ticketService.getAberturaTicketPadrao().subscribe({
      next: (result) => {
        const padrao = result?.categorizacaoClientePadrao;
        this.usarDelimitadorEmail = !!(padrao && padrao.is_usar_delimitador_email);

        if (!this.usarDelimitadorEmail) {
          return;
        }

        const blocoDelimitador = this.montarBlocoDelimitador();
        let corpoAtual = this.editorModel.editorData || '';

        // Assinatura já foi prependada por checkAssinaturaEmail; remove pra reposicionar dentro do bloco do delimitador.
        const assinaturaHtml = this.emailData?.emailSignature?.assinatura_html;
        if (assinaturaHtml && corpoAtual.startsWith(assinaturaHtml)) {
          corpoAtual = corpoAtual.slice(assinaturaHtml.length);
        }

        // Substitui o logFooter legado (data + observacao) pelo bloco com delimitador. Se não estiver presente
        // (sobrescrito por sugestão/peças), só anexa no fim, preservando qualquer draft/sugestão acima.
        if (this.logFooter && corpoAtual.indexOf(this.logFooter) !== -1) {
          corpoAtual = corpoAtual.replace(this.logFooter, blocoDelimitador);
        } else {
          corpoAtual = corpoAtual + blocoDelimitador;
        }

        this.editorModel.editorData = corpoAtual;
        this.descricao_aux = corpoAtual;
      },
      error: (error) => console.error('carregarConfigDelimitadorEAjustarCorpo', error)
    });
  }


  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
  }

  openTemplateModal(): void {
    const modalRef = this.modalService.open(
      ModalAdicionarTemplateComponent,
      {
        backdrop: "static",
        windowClass: "modal-custom-milvus",
        keyboard: false,
        size: "medio",
        scrollable: false,
      }
    );

    let data = 2;

    modalRef.componentInstance.tipoTemplate = data;
    modalRef.componentInstance.chamado_id = this.emailData?.chamado?.id ?? this.chatEmailData?.chat_id;
    modalRef.result.then((result) => {
      if (result) {
        this.editor.model.change(writer => {
          const viewFragment = this.editor.data.processor.toView(result.template);
          const modelFragment = this.editor.data.toModel(viewFragment);

          this.editor.model.insertContent(modelFragment, this.editor.model.document.selection.getFirstPosition());
        });
        // let index = this.editor.getSelection(true).index;
        // this.editor.clipboard.dangerouslyPasteHTML(index, result.template);
      }
    });
  }

  onEditorReady(editorInstance): void {
    this.editor = editorInstance;
  }

  checkFields(formName: string): boolean {
    return !(this.editorModel.editorData && this.editorModel.editorData.length > 12);
  }

  checkChatGPTSuggestion() {
    if (this.emailData.suggestion) {
      if (this.emailData.suggestion.exibicao_tipo !== 2 && this.emailData.suggestion.sugestao_html) {
        const sug = this.emailData.suggestion.sugestao_html;
        this.emailData.suggestion.sugestao_html = sug
          .replace(/(<br\s*\/?>)\s*\r?\n|\r?\n\s*(<br\s*\/?>)/gi, '$1$2')
          .replace(/\n/g, "<br>");
        if (!this.editorModel.editorData) {
          // this.envioEmail.descricao_html =
          //   (this.emailData.suggestion.saudacao ? this.emailData.suggestion.saudacao : '') +
          //   this.emailData.suggestion.sugestao_html;
          // this.sendEmailFromTicketForm.patchValue({
          //     subject: this.envioEmail.descricao_html
          // });
          this.editorModel.editorData = (this.emailData.suggestion.saudacao ? this.emailData.suggestion.saudacao : '') +
            this.emailData.suggestion.sugestao_html;
          this.descricao_aux = this.editorModel.editorData;
        } else {
          // this.envioEmail.descricao_html =
          //   (this.emailData.suggestion.saudacao ? this.emailData.suggestion.saudacao : '') +
          //   this.emailData.suggestion.sugestao_html +
          //   this.envioEmail.descricao_html;
          // this.sendEmailFromTicketForm.patchValue({
          //     subject: this.envioEmail.descricao_html
          // });
          this.editorModel.editorData =
            (this.emailData.suggestion.saudacao ? this.emailData.suggestion.saudacao : '') +
            this.emailData.suggestion.sugestao_html +
            this.editorModel.editorData;
          this.descricao_aux = this.editorModel.editorData;
        }
      } else {
        // this.envioEmail.descricao_html = this.emailData.descricao_html + this.logFooter;
        // this.sendEmailFromTicketForm.patchValue({
        //     subject: this.envioEmail.descricao_html
        // });
        this.editorModel.editorData = this.editorModel.editorData + this.logFooter;
        this.descricao_aux = this.editorModel.editorData;
      }
    }
  }

  checkAssinaturaEmail() {
    if (
      this.emailData.emailSignature &&
      this.emailData.emailSignature.assinatura_html
    ) {
      if (!this.editorModel.editorData) {
        // this.envioEmail.descricao_html = this.emailData.emailSignature.assinatura_html;
        // this.sendEmailFromTicketForm.patchValue({
        //     subject: this.envioEmail.descricao_html
        // });
        this.editorModel.editorData = this.emailData.emailSignature.assinatura_html;
        this.descricao_aux = this.editorModel.editorData;
      } else {
        // this.envioEmail.descricao_html =
        //   this.emailData.emailSignature.assinatura_html + this.envioEmail.descricao_html;
        // this.sendEmailFromTicketForm.patchValue({
        //     subject: this.envioEmail.descricao_html
        // });
        this.editorModel.editorData = this.emailData.emailSignature.assinatura_html + this.editorModel.editorData;
        this.descricao_aux = this.editorModel.editorData;
      }
    }
  }

  cleanChatGPTSuggestion() {
    if (this.emailData?.suggestion?.sugestao_html) {
      this.editorModel.editorData = this.editorModel.editorData.replace(
        this.emailData.suggestion.sugestao_html,
        " "
      );
      this.descricao_aux = this.editorModel.editorData;
      // this.sendEmailFromTicketForm.patchValue({
      //   subject: this.envioEmail.descricao_html
      // });
      this.likeOrDeslikeChatGPTSuggestion(this.emailData.suggestion, true);
    }
  }

  likeOrDeslikeChatGPTSuggestion(
    suggestion: ChatGPTSuggestionModel,
    like: boolean
  ) {
    let payload = {
      like: like,
    };
    this.newSubs = this.chatGPTService
      .likeOrDislikeSuggestion(suggestion.id, payload)
      .subscribe({
        next: (result) => {
          this.toastr.show(
            result.mensagem,
            "",
            environment.toastrConfig("success")
          );
        }, error: (error) => console.error('likeOrDeslikeChatGPTSuggestion', error)
      });
  }

  generateChatGPT() {
    let payload = {
      texto: this.sendEmailFromTicketForm.controls.chatGPT ? this.sendEmailFromTicketForm.controls.chatGPT.value : "",
      feature_id: IaConfiguracaoFeatureEnum.APOIO_NOVOS_EMAILS
    };

    const modalRefLoadingGpt = this.modalService.open(ModalOpenAITemplateComponent, {
      backdrop: "static",
      windowClass: "modal-custom-milvus",
      keyboard: true,
      size: "grande",
      scrollable: false,
    });

    modalRefLoadingGpt.componentInstance.apenasLoading = true;
    modalRefLoadingGpt.componentInstance.carregando = true;

    this.newSubs = this.chatGPTService.searchSuggestion(payload).subscribe({
      next: (result) => {
        modalRefLoadingGpt.componentInstance.carregando = false;
        const textoHtml = result?.data?.texto_html ?? '';
        if (!this.emailData) {
          this.emailData = {};
        }
        this.emailData.suggestion = {
          sugestao_html: textoHtml
        };
        this.toastr.show(
          result.mensagem,
          "",
          environment.toastrConfig("success")
        );
        if (this.editorModel.editorData) {
          this.editorModel.editorData = textoHtml + this.editorModel.editorData;
          this.descricao_aux = this.editorModel.editorData;
        } else {
          this.editorModel.editorData = textoHtml;
          this.descricao_aux = this.editorModel.editorData;
        }
      },
      error: (error) => {
        modalRefLoadingGpt.componentInstance.carregando = false;
        console.error('generateChatGPT', error);
      }
    });
  }

  setEmailContatoChamadoEmailData() {
    if (
      this.emailData.chamado.contato.email &&
      this.emailData.chamado.contato.email !== ""
    )
      this.envioEmail.destinatarios.push(this.emailData.chamado.contato.email);
  }

  setContatoEmailList(listaEmail) {
    listaEmail.forEach((element) => {
      if (element.email && element.email !== "") {
        this.envioEmail.destinatarios.push(element.email);
      }
    });
  }

  setContatoEmail(contatos) {
    if (contatos && contatos.length > 0) {
      this.setContatoEmailList(contatos);
    } else {
      this.setEmailContatoChamadoEmailData();
    }

    this.emailContato = this.envioEmail.destinatarios;
    this.contato = this.emailData.chamado.contato;
  }

  checkEmailContatos() {
    if (this.emailData.log && this.emailData.log.log_tipo_id === 12) {
      let email_criador = this.emailData.log.email_criador;
      let emails = []
      emails.push({ email: email_criador })
      if (this.emailData.log.cc) {
        let emailscc = this.emailData.log.cc.split(", ");
        emailscc = emailscc.map(element => { return { email: element } })
        emailscc.map(element => { emails.push(element) })
      }


      this.setContatoEmail(emails);
    } else if (this.emailData.log && (this.emailData.log.log_tipo_id === 18 || this.emailData.log.log_tipo_id === 24)) {
      let emails = []
      let log = this.emailData.log;

      if (log.email_criador) {
        emails.push({ email: log.email_criador });
        if (log.cc) {
          let emailscc = log.cc.split(", ");
          emailscc = emailscc.map(element => { return { email: element } });
          emailscc.map(element => { emails.push(element) });
        }

        if (log.email_para) {
          let emailspara = log.email_para.split(', ');
          emailspara.shift(); //remove primeiro e-mail pois é a própria caixa

          for (let mail of emailspara) {
            emails.push({ email: mail });
          }
        }
      } else if (log.contato) {
        // Fallback legado: log.contato normalmente guarda o nome de exibição do contato, não o e-mail.
        let contato = log.contato.split(", ");
        emails = contato.map(element => { return { email: element } })
      }

      if (emails.length > 0) {
        this.setContatoEmail(emails);
      } else {
        console.warn('Log sem email do contato!', this.emailData.log);
      }
    } else if (
      this.emailData.chamado.contatos &&
      this.emailData.chamado.contatos.length > 0
    ) {
      this.setContatoEmail(this.emailData.chamado.contatos);
    } else if (this.emailData.chamado.contato && this.emailData.chamado.contato.email) {
      var emails = this.emailData.chamado.contato.email.split(",");
      this.setContatoEmail(emails);
    } else if (this.emailData.contato) {
      var emails = this.emailData.chamado.contato.email.split(",");
      this.setContatoEmail(emails);
    } else if (this.emailData.log && this.emailData.log.contato) {
      var emails = this.emailData.log.contato.split(", ");
      this.setContatoEmail(emails);
    }
  }

  adicionaContatoEmail(contato): void {
    if (contato.email !== null) {
      this.emailContato = contato.email;
      this.envioEmail.destinatarios.push(contato.email);
    }
  }

  adicionaDestinatario(destinatario): void {
    this.envioEmail.destinatarios = [];
    destinatario.forEach((contato) => {
      if (typeof contato === "string") {
        this.envioEmail.destinatarios.push(contato);
      } else {
        this.envioEmail.destinatarios.push(contato[0]);
      }
    });
  }

  showInvalidEmail(): void {
    this.toastr.show(
      this.translate.instant("EMAIL_INVALIDO"),
      "",
      environment.toastrConfig("warning")
    );
  }

  cleanValueObservation(value): string {
    var _cleanText = new DOMParser().parseFromString(value, 'text/html');
    return _cleanText.body.textContent;
  }

  async iniciarEmailChat(): Promise<void> {
    this.salvando = true;
    let _cc = cloneDeep(this.envioEmail.destinatarios);
    _cc = _cc.slice(1);

    let _payload = {
      html_corpo_completo: this.editorModel.editorData,
      assunto: this.envioEmail.assunto,
      cc: _cc.map(dest => {
        if (dest.display) {
          return dest.display;
        } else {
          return dest;
        }
      }),
      contato_id: this.chatEmailData.contato_id,
      attachments: [],
      email_config_id: this.chatEmailData.caixa?.id
    };

    if (this.envioEmail.anexos.length) {
      for (let file of this.envioEmail.anexos) {
        _payload.attachments.push({
          filename: file.name,
          encoding: 'base64',
          contentType: file.type,
          content: await this.fileToBase64(file)
        });
      }
    }

    this.newSubs = this.chatService.iniciarChatEmail(_payload)
      .subscribe({
        next: (results) => {
          if (results) {
            this.modal.close(results.chat_id);
          }
        }, error: (error) => console.error(error)
      });
  }

  async enviarEmailChat(): Promise<void> {
    this.salvando = true;
    const htmlEditor = this.obterHtmlEditorRespostaChat().trim();
    const conteudoRespostaOperador = this.stripHtmlPipe.transform(
      this.obterConteudoRespostaOperadorRespostaChat(htmlEditor)
    );
    let _payload = {
      html_corpo_completo: htmlEditor,
      destinatarios: this.envioEmail.destinatarios.map(dest => {
        if (dest.display) {
          if (!this.chatEmailProps.cc.includes(dest.display)) return dest.display;
        } else if (!this.chatEmailProps.cc.includes(dest)) {
          return dest;
        }
      }),
      cc: this.chatEmailProps.cc,
      message_id_respondendo: this.chatEmailData.message_id,
      attachments: []
    };

    if (this.envioEmail.anexos.length) {
      for (let file of this.envioEmail.anexos) {
        _payload.attachments.push({
          filename: file.name,
          encoding: 'base64',
          contentType: file.type,
          content: await this.fileToBase64(file)
        });
      }
    }

    if (conteudoRespostaOperador.trim().length < 5) {
      this.salvando = false;
      this.toastr.show(this.translate.instant('NECESSARIO_CORPO_EMAIL'), '', environment.toastrConfig('warning'));
      return;
    }

    this.newSubs = this.chatService.respondeChatEmail(_payload, this.chatEmailData.chat_id)
      .subscribe({
        next: (results) => {
          this.toastr.show(this.translate.instant('ENVIADO_SUCESSO'), '', environment.toastrConfig('success'));
          this.modal.close(true);
        }, error: (error) => {
          this.salvando = false;
          console.error(error);
        }
      });
  }

  enviarEmail(): void {
    this.salvando = true;
    var _destinatarios = "";

    this.envioEmail.destinatarios.forEach((item) => {
      if (this.envioEmail.destinatarios.length > 1) {
        _destinatarios += item + ", ";
      } else {
        _destinatarios = item;
      }
    });

    let _payload = new FormData();
    _payload.append("chamado_id", this.emailData.chamado.id);
    _payload.append("ticket", this.emailData.chamado.codigo);
    _payload.append("assunto", this.envioEmail.assunto);
    _payload.append("destinatarios", _destinatarios);
    _payload.append("descricao_html", this.editorModel.editorData);

    _payload.append("descricao", this.stripHtmlPipe.transform(this.editorModel.editorData));

    _payload.append("chamado_assunto", this.emailData.chamado.assunto);
    _payload.append("chamado_descricao", this.emailData.chamado.descricao);
    _payload.append("usuario_cliente_id", this.emailData.chamado.cliente_id);

    if (this.envioEmail.anexos.length) {
      this.envioEmail.anexos.forEach(file => {
        _payload.append("file[]", file, file.name);
      });
    }

    this.newSubs = this.chatGPTService
      .useSuggestion(this.emailData.chamado.id)
      .subscribe({
        next: (result) => {
          this.toastr.show(
            result.mensagem,
            "",
            environment.toastrConfig("success")
          );
        }, error: (error) => console.error('enviarEmail', error)
      });

    this.newSubs = this.chamadosService.enviarEmailChamadoNovo(_payload).subscribe(
      (results) => {
        this.toastr.show(
          this.translate.instant("SALVO_SUCESSO"),
          "",
          environment.toastrConfig("success")
        );
        this.modal.close("criar");
      },
      (error) => {
        this.salvando = false;
      }
    );
  }

  verificaSeDesativa(): boolean {
    let validRecipients = this.envioEmail.destinatarios?.length > 0 ? true : false;

    let validSubject = this.envioEmail.assunto ? true : false;

    let validDescription = this.checkFields('description');

    return validRecipients && validSubject && validDescription;
  }

  verificaRequerido(valor): boolean {
    if (valor !== "") {
      return false;
    } else {
      return true;
    }
  }

  checkContatoExiste(result, index) {
    if (this.envioEmail.destinatarios.indexOf(result[index].email) === -1) {
      this.emailContato.push(result[index].email);
      this.envioEmail.destinatarios.push(result[index].email);
    } else {
      this.toastr.show(
        this.translate.instant("CONTATO_JA_ADD", {
          email: result[index].email,
        }),
        "",
        environment.toastrConfig("warning")
      );
    }
  }

  checkEmailContato(result, index) {
    if (!result[index].email) {
      this.toastr.show(
        this.translate.instant("NAO_HA_EMAIL_DESTE_CLIENTE"),
        "",
        environment.toastrConfig("warning")
      );
    } else {
      this.checkContatoExiste(result, index);
    }
  }

  abrirModalContatos(): void {
    let data: {
      cliente: any;
      contatosSelecionados: any[];
      tipo_solicitante_id?: number;
      solicitante_id?: number;
    };
    if (this.emailData?.chamado?.cliente) {
      data = {
        cliente: this.emailData.chamado.cliente,
        contatosSelecionados: [],
      };
    } else if (this.chatContatosContext) {
      data = this.chatContatosContext;
    } else {
      this.toastr.show(
        this.translate.instant('AVISO_SEM_CLIENTE_MANDAR_CHAT_EMAIL'),
        "",
        environment.toastrConfig("warning")
      );
      return;
    }
    const modalRef = this.modalService.open(
      ModalListaContatosClienteComponent,
      {
        backdrop: "static",
        windowClass: "modal-custom-milvus",
        keyboard: false,
        size: "medio",
        scrollable: false,
      }
    );
    modalRef.componentInstance.contatoData = data;
    modalRef.result.then((result) => {
      if (result) {
        this.emailContato = [];
        for (let i = 0; i < result.length; i++) {
          this.checkEmailContato(result, i);
        }
      }
    });
  }

  triggerFileInput(): void {
    let fileInput = document.getElementById("fileInputEmail");
    fileInput.click();
  }

  onFileDropped(event) {
    this.changeFile(event);
  }

  changeFile(file): void {
    if (file.length > 0 && file.length <= this.limit_max) {
      for (let i = 0; i < file.length; i++) {
        var mime = require("mime");
        var tipo = mime.getType(file[0].name);

        if (tipo !== null) {
          tipo = tipo.split("/");
        } else {
          let ext = file[0].name.split(".");
          tipo = ext;
        }

        tipo[1] = environment.convertUploadType(tipo[1]);

        var suportado = this.uploadFileType.indexOf(tipo[1]);
        if (file[i] && file[i].size <= this.uploadFileSize && suportado !== -1) {
          if (this.envioEmail.anexos.length < 5) {
            var reader = new FileReader();
            reader.readAsDataURL(file[i]);
            reader.onload = (event) => {
              this.anexos.push({
                name: file[i].name,
                type: file[i].type,
                url: this._sanitizer.sanitize(SecurityContext.URL,
                  event.target.result.toString()
                ),
              });
            };
            this.envioEmail.anexos.push(file[i]);
          } else {
            this.toastr.show(this.translate.instant('QNT_ANEXOS_EXCEDIDO'), '', environment.toastrConfig('warning'));
          }
        } else {
          this.toastr.show(
            this.translate.instant("ARQUIVO_NAO_SUPORTADO_OU_EXCEDEU_LIMITE"),
            "",
            environment.toastrConfig("warning")
          );
        }
      }
    } else if (file.length >= 6) {
      this.toastr.show(this.translate.instant('QNT_ANEXOS_EXCEDIDO'), '', environment.toastrConfig('warning'));
    }
  }

  downloadAnexo(anexo) {
    var fileName = anexo.name;
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.setAttribute("style", "display: none");
    var fileURL = anexo.url;
    a.href = fileURL;
    a.target = "_blank";
    a.download = fileName;
    document.body.appendChild(a);

    setTimeout(() => {
      a.click();
      window.URL.revokeObjectURL(fileURL);
    });
  }

  excluirAnexo(index): void {
    swal
      .fire({
        title: this.translate.instant("DESEJA_EXCLUIR_ANEXO"),
        icon: "error",
        focusConfirm: true,
        showCancelButton: true,
        confirmButtonText: this.translate.instant("SIM"),
        cancelButtonText: this.translate.instant("NAO"),
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.anexos.splice(index, 1);
          this.envioEmail.anexos.splice(index, 1);
        }
      });
  }

  private obterHtmlEditorRespostaChat(): string {
    const htmlCkeditor = typeof this.editor?.getData === 'function' ? this.editor.getData() : '';
    const htmlNgModel = this.editorModel.editorData || '';
    return htmlCkeditor || htmlNgModel;
  }

  private obterConteudoRespostaOperadorRespostaChat(html: string): string {
    if (!html?.trim()) {
      return '';
    }

    const documentoHtml = new DOMParser().parseFromString(html, 'text/html');
    const blockquoteCitacao = documentoHtml.body.querySelector('blockquote');
    const partesConteudoResposta: string[] = [];

    for (const noFilho of Array.from(documentoHtml.body.childNodes)) {
      if (blockquoteCitacao && noFilho === blockquoteCitacao) {
        break;
      }

      if (noFilho.nodeType === Node.ELEMENT_NODE) {
        const elementoAtual = noFilho as Element;
        const textoElemento = (elementoAtual.textContent || '').replace(/\u00a0/g, ' ').trim();

        if (elementoAtual.tagName === 'P' && !textoElemento) {
          continue;
        }

        partesConteudoResposta.push(elementoAtual.outerHTML);
      } else if (noFilho.nodeType === Node.TEXT_NODE && noFilho.textContent?.trim()) {
        partesConteudoResposta.push(noFilho.textContent);
      }
    }

    return partesConteudoResposta.join('').trim();
  }

  fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const result = reader.result as string;
        // Removes the prefix (e.g., "data:image/png;base64,")
        resolve(result.split(',')[1]);
      };
      reader.onerror = (error) => reject(error);
    });
  }
}
